export const MenuItem=[
    {
        title:"About",
        cName:"nav-link",
        url: "/",
        icon: "fa-solid fa-address-card"
    },
    {
        title:"My Skills",
        cName:"nav-link",
        url: "/skills",
        icon: "fa-solid fa-star"
    },
    {
        title:"Projets",
        cName:"nav-link",
        url: "/project",
        icon: "fas fa-project-diagram"
    },
    {
        title:"Contact",
        cName:"nav-link",
        url: "/contact",
        icon: "fa-regular fa-id-badge"
    }
]